import { render, staticRenderFns } from "./LendaIcon.vue?vue&type=template&id=b574175a&scoped=true"
import script from "./LendaIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./LendaIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LendaIcon.vue?vue&type=style&index=0&id=b574175a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b574175a",
  null
  
)

export default component.exports